import { render, staticRenderFns } from "./registerPassPhrase.vue?vue&type=template&id=1359d8ea&"
import script from "./registerPassPhrase.vue?vue&type=script&lang=js&"
export * from "./registerPassPhrase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports